<template>
<div :data-testid="TEST_ID.GARANTIA_CARD.ROOT">
  <el-card>
    <div class="cardBody">
      <div :data-testid="TEST_ID.GARANTIA_CARD.TOGGLE_DETAILS" :class="opened ? 'triangleDown' : 'triangleRight'" @click="toggleOpen"></div>
      <el-tag
        :data-testid="TEST_ID.GARANTIA_CARD.STATUS"
        class="tag"
        :type="garantia.EnGarantia ? 'success' : 'danger'"
        size="small"
        disable-transitions>{{ garantia.EnGarantia ? $t('GARANTIAS_en_garantia') : $t('GARANTIAS_sin_garantia')}}
      </el-tag>
      <div class="username">{{garantia.Usuario !== "" ? garantia.Usuario : garantia.Ns}}</div>
      <div class="ns_dominio">{{garantia.Usuario !== "" ? garantia.Ns : garantia.Dominio}}</div>
      <div class="ns_dominio">{{garantia.Usuario !== "" ? garantia.Dominio : ""}}</div>
      <div class="ns_dominio">{{ $filters.defaultEmpty(garantia.CodigoProducto) }}</div>

      <transition name="fade">
        <div class="info" :data-testid="TEST_ID.GARANTIA_CARD.DETAILS" v-show="opened">
          <table style="width: 100%">
            <tbody>
              <tr class="row_spacing" :data-testid="TEST_ID.GARANTIA_CARD.FIELD_TELEFONO">
                <td class="greyLabel"><span>{{$t('GARANTIAS_telefono')}}: </span></td>
                <td><div class="blackLabel">{{garantia.Telefono}}</div></td>
              </tr>
              <tr class="row_spacing" :data-testid="TEST_ID.GARANTIA_CARD.FIELD_INSTALADO">
                <td class="greyLabel"><span>{{$t('GARANTIAS_instalado')}}: </span></td>
                <td><div class="blackLabel">{{ $filters.formatDate(garantia.FechaInstalacion) }}</div></td>
              </tr>
              <tr class="row_spacing" :data-testid="TEST_ID.GARANTIA_CARD.FIELD_GARANTIA_VENCE">
                <td class="greyLabel"><span>{{$t('GARANTIAS_vence')}}: </span></td>
                <td><div class="blackLabel">{{ $filters.formatDate(garantia.FechaVencimiento) }}</div></td>
              </tr>
            <!-- <tr class="row_spacing">
              <td class="greyLabel"><span>{{$t('GARANTIAS_cod_prod')}}: </span></td>
              <td><div class="blackLabel">{{ $defaultEmpty(garantia.CodigoProducto) }}</div></td>
            </tr> -->
            <tr class="row_spacing" :data-testid="TEST_ID.GARANTIA_CARD.FIELD_DESCRIPCION">
              <td class="greyLabel"><span>{{$t('GARANTIAS_producto_descripcion')}}: </span></td>
              <td><div class="blackLabel">{{ $filters.defaultEmpty(garantia.ProductoDescripcion) }}</div></td>
            </tr>  
            <tr class="row_spacing" :data-testid="TEST_ID.GARANTIA_CARD.FIELD_GARANTIA">
              <td class="greyLabel"><span>{{$t('GARANTIAS_garantia')}}: </span></td>
              <td><div class="blackLabel">{{garantia.MesesGarantia}} {{$t('GARANTIAS_meses')}}</div></td>
            </tr>
            <tr class="row_spacing" :data-testid="TEST_ID.GARANTIA_CARD.FIELD_GARANTIA_ADIC">
              <td class="greyLabel"><span>{{$t('GARANTIAS_garantia_adic')}}: </span></td>
              <td><div class="blackLabel">{{garantia.MesesAdicionalesGarantia}} {{$t('GARANTIAS_meses')}}</div></td>
            </tr>
            <tr class="row_spacing" :data-testid="TEST_ID.GARANTIA_CARD.FIELD_REGISTRADO_POR">
              <td class="greyLabel"><span>{{$t('GARANTIAS_registrado_por')}}: </span></td>
              <td><div class="blackLabel">{{ $filters.defaultEmpty(garantia.RegistradoPor) }}</div></td>
            </tr>                  
            <tr class="row_spacing" :data-testid="TEST_ID.GARANTIA_CARD.FIELD_SERVICIO_OFICIAL">
              <td class="greyLabel"><span>{{$t('GARANTIAS_servicio_oficial')}}: </span></td>
              <td><div class="blackLabel">{{ $filters.defaultEmpty(garantia.ServicioOficial) }}</div></td>
            </tr>                                                               
            </tbody>
          </table>
        </div>    
      </transition>
    </div>
  </el-card>
</div>
</template>

<script>
import TEST_ID from "@/testIds.json";

export default {
  props: {
    garantia: Object,
  },
  data() {
    return {
      TEST_ID,
      opened: false
    }
  },
  methods: {
    toggleOpen() {
      this.opened = !this.opened      
    }
  },
}
</script>

<style>
.el-card__body {
  min-height: 42px;
}
</style>


<style scoped>
.username {
  font-size: 14px;
  font-weight: bold;
  text-align: left;
}
.ns_dominio {
  font-size: 12px;
  font-weight: bold;
  color: #6b6b6b;
  text-align: left;
}
.tag {
  float: right;
  margin-top: 7px;
}
.triangleRight {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 8px 0 8px 13.9px;
  border-color: transparent transparent transparent var(--main-color);
  position: absolute;
  left: 18px;
  top: 28px;
  cursor: pointer;
}
.triangleDown {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 13.9px 8px 0 8px;
  border-color: var(--main-color) transparent transparent transparent;
  position: absolute;
  left: 18px;
  top: 28px;
  cursor: pointer;
}
.cardBody {
  padding-left: 25px;
}
.greyLabel {
  font-size: 14px;
  color: #6B6B6B;
  text-align: left;
  font-weight: normal;
}
.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  font-weight: bold;
}
.row_spacing {
  height: 20px;
}
</style>
